/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedSLUModelListList } from '../models/PaginatedSLUModelListList';
import type { PaginatedSLUModelWriteSerializerWithReprList } from '../models/PaginatedSLUModelWriteSerializerWithReprList';
import type { PatchedSLUModelWriteSerializerWithRepr } from '../models/PatchedSLUModelWriteSerializerWithRepr';
import type { SLUModelRead } from '../models/SLUModelRead';
import type { SLUModelWriteSerializerWithRepr } from '../models/SLUModelWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SluModelsService {
    /**
     * @returns PaginatedSLUModelListList
     * @throws ApiError
     */
    public static sluModelsList({
        entities,
        excludeFields,
        fields,
        intentAlias,
        intents,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        entities?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        intentAlias?: Array<string>,
        intents?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedSLUModelListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/slu-models/',
            query: {
                'entities': entities,
                'exclude-fields': excludeFields,
                'fields': fields,
                'intent_alias': intentAlias,
                'intents': intents,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns SLUModelWriteSerializerWithRepr
     * @throws ApiError
     */
    public static sluModelsCreate({
        requestBody,
    }: {
        requestBody: SLUModelWriteSerializerWithRepr,
    }): CancelablePromise<SLUModelWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/slu-models/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedSLUModelWriteSerializerWithReprList
     * @throws ApiError
     */
    public static sluModelBulkUpdate({
        requestBody,
        entities,
        excludeFields,
        fields,
        intentAlias,
        intents,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<SLUModelWriteSerializerWithRepr>,
        entities?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        intentAlias?: Array<string>,
        intents?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedSLUModelWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/slu-models/',
            query: {
                'entities': entities,
                'exclude-fields': excludeFields,
                'fields': fields,
                'intent_alias': intentAlias,
                'intents': intents,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedSLUModelWriteSerializerWithReprList
     * @throws ApiError
     */
    public static sluModelBulkPartialUpdate({
        requestBody,
        entities,
        excludeFields,
        fields,
        intentAlias,
        intents,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<SLUModelWriteSerializerWithRepr>,
        entities?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        intentAlias?: Array<string>,
        intents?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedSLUModelWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/slu-models/',
            query: {
                'entities': entities,
                'exclude-fields': excludeFields,
                'fields': fields,
                'intent_alias': intentAlias,
                'intents': intents,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static sluModelBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/slu-models/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns SLUModelRead
     * @throws ApiError
     */
    public static sluModelsRetrieve({
        id,
        entities,
        excludeFields,
        fields,
        intentAlias,
        intents,
        languages,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this slu model.
         */
        id: number,
        entities?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        intentAlias?: Array<string>,
        intents?: Array<string>,
        languages?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<SLUModelRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/slu-models/{id}/',
            path: {
                'id': id,
            },
            query: {
                'entities': entities,
                'exclude-fields': excludeFields,
                'fields': fields,
                'intent_alias': intentAlias,
                'intents': intents,
                'languages': languages,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns SLUModelWriteSerializerWithRepr
     * @throws ApiError
     */
    public static sluModelsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this slu model.
         */
        id: number,
        requestBody: SLUModelWriteSerializerWithRepr,
    }): CancelablePromise<SLUModelWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/slu-models/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SLUModelWriteSerializerWithRepr
     * @throws ApiError
     */
    public static sluModelsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this slu model.
         */
        id: number,
        requestBody?: PatchedSLUModelWriteSerializerWithRepr,
    }): CancelablePromise<SLUModelWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/slu-models/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static sluModelsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this slu model.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/slu-models/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
